<template>
  <div
    class="absolute content-center bottom-1 left-1 z-20"
    role="button"
    @click="toggleStreamState"
  >
    <div class="tooltip">
      <PlayCircleIcon v-if="isStreamMuted" />
      <PauseCircleIcon v-else />
      <span class="tooltip-text ml-2">
        {{ isStreamMuted ? 'Continue' : 'Pause' }}
      </span>
    </div>
  </div>
</template>

<script>
import PlayCircleIcon from '@/Components/Icons/PlayCircleIcon.vue';
import PauseCircleIcon from '@/Components/Icons/PauseCircleIcon.vue';

export default {
  name: 'ToggleMuteStream',
  emits: ['stream-state-toggled'],
  props: {
    isStreamMuted: Boolean,
    label: String,
  },
  components: {
    PauseCircleIcon,
    PlayCircleIcon,
  },

  setup(props, { emit }) {
    const toggleStreamState = () => {
      emit('stream-state-toggled', !props.isStreamMuted);
    };
    return {
      toggleStreamState,
    };
  },
};
</script>

<style scoped>
.tooltip-text {
  visibility: hidden;
  padding: 3px 5px 1px 5px;
  border: 1px solid #d8d8d8;
  width: max-content;
  background-color: #eeeeee;
  color: #134e4a;
  text-align: center;
  border-radius: 6px;
  font-weight: 500;
  font-size: smaller;
  position: absolute;
  opacity: 0.9;
  z-index: 1;
  top: 10px;
  left: 90%;
}
</style>
